import { render, staticRenderFns } from "./AreaPath.vue?vue&type=template&id=3546d137&"
import script from "./AreaPath.vue?vue&type=script&lang=js&"
export * from "./AreaPath.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports